module.exports = __webpack_public_path__ + "65a865c267d08877ac6727237bc70b0f.jpg";